import { devtools } from "zustand/middleware";
import { create } from "zustand/react";

type InspectionModalState = {
  isOpen: boolean;
  orderId: number | null;
  open: (orderId: number) => void;
  close: () => void;
};

export const useInspectionModalStore = create<InspectionModalState>()(
  devtools((set) => ({
    isOpen: false,
    orderId: null,
    open: (orderId) => set({ isOpen: true, orderId }),
    close: () => set({ isOpen: false, orderId: null }),
  }))
);
